import { Component, Input, forwardRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PickupArea } from 'app/models/locations';

@Component({
  selector: 'app-pickup-area-select',
  templateUrl: './pickup-area-select.component.html',
  styleUrls: ['./pickup-area-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PickupAreaSelectComponent),
    multi: true
  }]
})

export class PickupAreaSelectComponent implements ControlValueAccessor, OnInit, OnChanges {
  @Input() public availablePickupArea: PickupArea[];
  @Input() public selectedPickupAreaCode: string;
  @Input() public dataAutomationId: string;
  public disabled: boolean;
  public hasValidPickupAreas: boolean;

  private onChange: (value: string) => void;
  private onTouched: () => void;

  ngOnInit(): void {
    this.setHasValidPickupAreas();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.availablePickupArea) {
      this.setHasValidPickupAreas();
    }
  }

  writeValue(value: string): void {
    this.selectedPickupAreaCode = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private setHasValidPickupAreas(): void {
    this.hasValidPickupAreas = this.availablePickupArea?.some(area => area.code);
  }

  onPickupAreaChange(areaCode: string) {
    this.writeValue(areaCode);
    this.onChange(areaCode);
    this.onTouched();
  }
}
